const state = () => {
  return {
    notes: [
      {
        title: "Section 352 (4) ACJA",
        content:
          "Where the Court, in exercise of its discretion, has granted bail to the defendant and the defendant, in disregard for the court orders, fails to surrender to the order of court or fails to attend court without reasonable explanation, the court shall continue with the trial in his absence and convict him unless the court sees reasons otherwise, provided that proceedings in the absence of the defendant shall take place after two adjournments or as the court may deem fit."
      },
      {
        title: "Section 396 (3) ACJA",
        content:
          "Upon arraignment, the trial of the defendant shall proceed from day to day until the conclusion of the trial."
      },
      {
        title: "Section 396 (4) ACJA",
        content:
          "Where day-to-day trial is impracticable after arraignment, no party shall be entitled to more than five adjournments from arraignment to final judgment provided that the interval between each adjournment shall not exceed 14 working days."
      },
      {
        title: "Section 396 (4) ACJA",
        content:
          "Where it is impracticable to conclude a criminal proceeding after the parties have exhausted their five adjournments each, the interval between one adjournment to another shall not exceed seven days inclusive of weekends."
      }
    ]
  };
};

// getters
const getters = {
  notes: state => state.notes
};

// actions
const actions = {};

// mutations
const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
